import { CircularProgress, CircularProgressProps } from '@mui/material';
import { styled } from '@mui/material';

import { COLORS } from '~/styles/colors';

export default function Loader(props: CircularProgressProps) {
  return <StyledCircularProgress {...props} />;
}

export const StyledCircularProgress = styled(CircularProgress)(() => ({
  '& circle': {
    stroke: COLORS.primary,
  },
}));
